/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as R2faRouteImport } from './routes/2fa'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as publicRouteRouteImport } from './routes/(public)/route'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as publicIndexRouteImport } from './routes/(public)/index'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppProfileRouteImport } from './routes/app/profile'
import { Route as AppNotificationsRouteImport } from './routes/app/notifications'
import { Route as publicTermsRouteImport } from './routes/(public)/terms'
import { Route as publicPrivacyRouteImport } from './routes/(public)/privacy'
import { Route as publicPricingRouteImport } from './routes/(public)/pricing'
import { Route as publicFeaturesRouteImport } from './routes/(public)/features'
import { Route as publicAboutRouteImport } from './routes/(public)/about'
import { Route as AppOnboardingRouteRouteImport } from './routes/app/onboarding/route'
import { Route as AppGamesRouteRouteImport } from './routes/app/games/route'
import { Route as AppAdminRouteRouteImport } from './routes/app/admin/route'
import { Route as AppGamesIndexRouteImport } from './routes/app/games/index'
import { Route as AppClubsIndexRouteImport } from './routes/app/clubs/index'
import { Route as AppUsersSlugRouteImport } from './routes/app/users/$slug'
import { Route as AppOnboardingStep4RouteImport } from './routes/app/onboarding/step-4'
import { Route as AppOnboardingStep3RouteImport } from './routes/app/onboarding/step-3'
import { Route as AppOnboardingStep2RouteImport } from './routes/app/onboarding/step-2'
import { Route as AppOnboardingStep1RouteImport } from './routes/app/onboarding/step-1'
import { Route as AppMatchShortIdRouteImport } from './routes/app/match.$shortId'
import { Route as AppDevNodePreviewRouteImport } from './routes/app/dev/node-preview'
import { Route as AppDevFlowRunnerRouteImport } from './routes/app/dev/flow-runner'
import { Route as AppClubsSlugRouteRouteImport } from './routes/app/clubs/$slug/route'
import { Route as AppGamesGameIndexRouteImport } from './routes/app/games/$game/index'
import { Route as AppClubsSlugIndexRouteImport } from './routes/app/clubs/$slug/index'
import { Route as AppAdminGamesIndexRouteImport } from './routes/app/admin/games/index'
import { Route as AppClubsJoinCodeRouteImport } from './routes/app/clubs/join/$code'
import { Route as AppClubsSlugStatsRouteImport } from './routes/app/clubs/$slug/stats'
import { Route as AppClubsSlugSettingsRouteImport } from './routes/app/clubs/$slug/settings'
import { Route as AppClubsSlugQueueSettingsRouteImport } from './routes/app/clubs/$slug/queue-settings'
import { Route as AppClubsSlugMembersRouteImport } from './routes/app/clubs/$slug/members'
import { Route as AppClubsSlugMatchesRouteImport } from './routes/app/clubs/$slug/matches'
import { Route as AppAdminGamesGameIdRouteImport } from './routes/app/admin/games/$gameId'
import { Route as AppClubsSlugAdminRouteRouteImport } from './routes/app/clubs/$slug/admin/route'
import { Route as AppClubsSlugAdminIndexRouteImport } from './routes/app/clubs/$slug/admin/index'
import { Route as AppClubsSlugAdminModerationRouteImport } from './routes/app/clubs/$slug/admin/moderation'
import { Route as AppClubsSlugAdminDisputesRouteImport } from './routes/app/clubs/$slug/admin/disputes'
import { Route as AppClubsSlugAdminAnalyticsRouteImport } from './routes/app/clubs/$slug/admin/analytics'
import { Route as AppClubsSlugQueuesQueueSlugIndexRouteImport } from './routes/app/clubs/$slug/queues/$queueSlug/index'
import { Route as AppClubsSlugQueuesQueueSlugSettingsRouteImport } from './routes/app/clubs/$slug/queues/$queueSlug/settings'
import { Route as AppClubsSlugQueuesQueueSlugFlowEditorRouteImport } from './routes/app/clubs/$slug/queues/$queueSlug/flow-editor'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const R2faRoute = R2faRouteImport.update({
  id: '/2fa',
  path: '/2fa',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const publicRouteRoute = publicRouteRouteImport.update({
  id: '/(public)',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const publicIndexRoute = publicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => publicRouteRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRouteRoute,
} as any)
const publicTermsRoute = publicTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicPrivacyRoute = publicPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicPricingRoute = publicPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicFeaturesRoute = publicFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicAboutRoute = publicAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => publicRouteRoute,
} as any)
const AppOnboardingRouteRoute = AppOnboardingRouteRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppGamesRouteRoute = AppGamesRouteRouteImport.update({
  id: '/games',
  path: '/games',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminRouteRoute = AppAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppGamesIndexRoute = AppGamesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppGamesRouteRoute,
} as any)
const AppClubsIndexRoute = AppClubsIndexRouteImport.update({
  id: '/clubs/',
  path: '/clubs/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppUsersSlugRoute = AppUsersSlugRouteImport.update({
  id: '/users/$slug',
  path: '/users/$slug',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOnboardingStep4Route = AppOnboardingStep4RouteImport.update({
  id: '/step-4',
  path: '/step-4',
  getParentRoute: () => AppOnboardingRouteRoute,
} as any)
const AppOnboardingStep3Route = AppOnboardingStep3RouteImport.update({
  id: '/step-3',
  path: '/step-3',
  getParentRoute: () => AppOnboardingRouteRoute,
} as any)
const AppOnboardingStep2Route = AppOnboardingStep2RouteImport.update({
  id: '/step-2',
  path: '/step-2',
  getParentRoute: () => AppOnboardingRouteRoute,
} as any)
const AppOnboardingStep1Route = AppOnboardingStep1RouteImport.update({
  id: '/step-1',
  path: '/step-1',
  getParentRoute: () => AppOnboardingRouteRoute,
} as any)
const AppMatchShortIdRoute = AppMatchShortIdRouteImport.update({
  id: '/match/$shortId',
  path: '/match/$shortId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDevNodePreviewRoute = AppDevNodePreviewRouteImport.update({
  id: '/dev/node-preview',
  path: '/dev/node-preview',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDevFlowRunnerRoute = AppDevFlowRunnerRouteImport.update({
  id: '/dev/flow-runner',
  path: '/dev/flow-runner',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppClubsSlugRouteRoute = AppClubsSlugRouteRouteImport.update({
  id: '/clubs/$slug',
  path: '/clubs/$slug',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppGamesGameIndexRoute = AppGamesGameIndexRouteImport.update({
  id: '/$game/',
  path: '/$game/',
  getParentRoute: () => AppGamesRouteRoute,
} as any)
const AppClubsSlugIndexRoute = AppClubsSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppClubsSlugRouteRoute,
} as any)
const AppAdminGamesIndexRoute = AppAdminGamesIndexRouteImport.update({
  id: '/games/',
  path: '/games/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppClubsJoinCodeRoute = AppClubsJoinCodeRouteImport.update({
  id: '/clubs/join/$code',
  path: '/clubs/join/$code',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppClubsSlugStatsRoute = AppClubsSlugStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => AppClubsSlugRouteRoute,
} as any)
const AppClubsSlugSettingsRoute = AppClubsSlugSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppClubsSlugRouteRoute,
} as any)
const AppClubsSlugQueueSettingsRoute =
  AppClubsSlugQueueSettingsRouteImport.update({
    id: '/queue-settings',
    path: '/queue-settings',
    getParentRoute: () => AppClubsSlugRouteRoute,
  } as any)
const AppClubsSlugMembersRoute = AppClubsSlugMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppClubsSlugRouteRoute,
} as any)
const AppClubsSlugMatchesRoute = AppClubsSlugMatchesRouteImport.update({
  id: '/matches',
  path: '/matches',
  getParentRoute: () => AppClubsSlugRouteRoute,
} as any)
const AppAdminGamesGameIdRoute = AppAdminGamesGameIdRouteImport.update({
  id: '/games/$gameId',
  path: '/games/$gameId',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppClubsSlugAdminRouteRoute = AppClubsSlugAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppClubsSlugRouteRoute,
} as any)
const AppClubsSlugAdminIndexRoute = AppClubsSlugAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppClubsSlugAdminRouteRoute,
} as any)
const AppClubsSlugAdminModerationRoute =
  AppClubsSlugAdminModerationRouteImport.update({
    id: '/moderation',
    path: '/moderation',
    getParentRoute: () => AppClubsSlugAdminRouteRoute,
  } as any)
const AppClubsSlugAdminDisputesRoute =
  AppClubsSlugAdminDisputesRouteImport.update({
    id: '/disputes',
    path: '/disputes',
    getParentRoute: () => AppClubsSlugAdminRouteRoute,
  } as any)
const AppClubsSlugAdminAnalyticsRoute =
  AppClubsSlugAdminAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AppClubsSlugAdminRouteRoute,
  } as any)
const AppClubsSlugQueuesQueueSlugIndexRoute =
  AppClubsSlugQueuesQueueSlugIndexRouteImport.update({
    id: '/queues/$queueSlug/',
    path: '/queues/$queueSlug/',
    getParentRoute: () => AppClubsSlugRouteRoute,
  } as any)
const AppClubsSlugQueuesQueueSlugSettingsRoute =
  AppClubsSlugQueuesQueueSlugSettingsRouteImport.update({
    id: '/queues/$queueSlug/settings',
    path: '/queues/$queueSlug/settings',
    getParentRoute: () => AppClubsSlugRouteRoute,
  } as any)
const AppClubsSlugQueuesQueueSlugFlowEditorRoute =
  AppClubsSlugQueuesQueueSlugFlowEditorRouteImport.update({
    id: '/queues/$queueSlug/flow-editor',
    path: '/queues/$queueSlug/flow-editor',
    getParentRoute: () => AppClubsSlugRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/app': typeof AppRouteRouteWithChildren
  '/2fa': typeof R2faRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/app/admin': typeof AppAdminRouteRouteWithChildren
  '/app/games': typeof AppGamesRouteRouteWithChildren
  '/app/onboarding': typeof AppOnboardingRouteRouteWithChildren
  '/about': typeof publicAboutRoute
  '/features': typeof publicFeaturesRoute
  '/pricing': typeof publicPricingRoute
  '/privacy': typeof publicPrivacyRoute
  '/terms': typeof publicTermsRoute
  '/app/notifications': typeof AppNotificationsRoute
  '/app/profile': typeof AppProfileRoute
  '/app/settings': typeof AppSettingsRoute
  '/': typeof publicIndexRoute
  '/app/': typeof AppIndexRoute
  '/app/clubs/$slug': typeof AppClubsSlugRouteRouteWithChildren
  '/app/dev/flow-runner': typeof AppDevFlowRunnerRoute
  '/app/dev/node-preview': typeof AppDevNodePreviewRoute
  '/app/match/$shortId': typeof AppMatchShortIdRoute
  '/app/onboarding/step-1': typeof AppOnboardingStep1Route
  '/app/onboarding/step-2': typeof AppOnboardingStep2Route
  '/app/onboarding/step-3': typeof AppOnboardingStep3Route
  '/app/onboarding/step-4': typeof AppOnboardingStep4Route
  '/app/users/$slug': typeof AppUsersSlugRoute
  '/app/clubs/': typeof AppClubsIndexRoute
  '/app/games/': typeof AppGamesIndexRoute
  '/app/clubs/$slug/admin': typeof AppClubsSlugAdminRouteRouteWithChildren
  '/app/admin/games/$gameId': typeof AppAdminGamesGameIdRoute
  '/app/clubs/$slug/matches': typeof AppClubsSlugMatchesRoute
  '/app/clubs/$slug/members': typeof AppClubsSlugMembersRoute
  '/app/clubs/$slug/queue-settings': typeof AppClubsSlugQueueSettingsRoute
  '/app/clubs/$slug/settings': typeof AppClubsSlugSettingsRoute
  '/app/clubs/$slug/stats': typeof AppClubsSlugStatsRoute
  '/app/clubs/join/$code': typeof AppClubsJoinCodeRoute
  '/app/admin/games/': typeof AppAdminGamesIndexRoute
  '/app/clubs/$slug/': typeof AppClubsSlugIndexRoute
  '/app/games/$game/': typeof AppGamesGameIndexRoute
  '/app/clubs/$slug/admin/analytics': typeof AppClubsSlugAdminAnalyticsRoute
  '/app/clubs/$slug/admin/disputes': typeof AppClubsSlugAdminDisputesRoute
  '/app/clubs/$slug/admin/moderation': typeof AppClubsSlugAdminModerationRoute
  '/app/clubs/$slug/admin/': typeof AppClubsSlugAdminIndexRoute
  '/app/clubs/$slug/queues/$queueSlug/flow-editor': typeof AppClubsSlugQueuesQueueSlugFlowEditorRoute
  '/app/clubs/$slug/queues/$queueSlug/settings': typeof AppClubsSlugQueuesQueueSlugSettingsRoute
  '/app/clubs/$slug/queues/$queueSlug/': typeof AppClubsSlugQueuesQueueSlugIndexRoute
}
export interface FileRoutesByTo {
  '/2fa': typeof R2faRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/app/admin': typeof AppAdminRouteRouteWithChildren
  '/app/onboarding': typeof AppOnboardingRouteRouteWithChildren
  '/about': typeof publicAboutRoute
  '/features': typeof publicFeaturesRoute
  '/pricing': typeof publicPricingRoute
  '/privacy': typeof publicPrivacyRoute
  '/terms': typeof publicTermsRoute
  '/app/notifications': typeof AppNotificationsRoute
  '/app/profile': typeof AppProfileRoute
  '/app/settings': typeof AppSettingsRoute
  '/': typeof publicIndexRoute
  '/app': typeof AppIndexRoute
  '/app/dev/flow-runner': typeof AppDevFlowRunnerRoute
  '/app/dev/node-preview': typeof AppDevNodePreviewRoute
  '/app/match/$shortId': typeof AppMatchShortIdRoute
  '/app/onboarding/step-1': typeof AppOnboardingStep1Route
  '/app/onboarding/step-2': typeof AppOnboardingStep2Route
  '/app/onboarding/step-3': typeof AppOnboardingStep3Route
  '/app/onboarding/step-4': typeof AppOnboardingStep4Route
  '/app/users/$slug': typeof AppUsersSlugRoute
  '/app/clubs': typeof AppClubsIndexRoute
  '/app/games': typeof AppGamesIndexRoute
  '/app/admin/games/$gameId': typeof AppAdminGamesGameIdRoute
  '/app/clubs/$slug/matches': typeof AppClubsSlugMatchesRoute
  '/app/clubs/$slug/members': typeof AppClubsSlugMembersRoute
  '/app/clubs/$slug/queue-settings': typeof AppClubsSlugQueueSettingsRoute
  '/app/clubs/$slug/settings': typeof AppClubsSlugSettingsRoute
  '/app/clubs/$slug/stats': typeof AppClubsSlugStatsRoute
  '/app/clubs/join/$code': typeof AppClubsJoinCodeRoute
  '/app/admin/games': typeof AppAdminGamesIndexRoute
  '/app/clubs/$slug': typeof AppClubsSlugIndexRoute
  '/app/games/$game': typeof AppGamesGameIndexRoute
  '/app/clubs/$slug/admin/analytics': typeof AppClubsSlugAdminAnalyticsRoute
  '/app/clubs/$slug/admin/disputes': typeof AppClubsSlugAdminDisputesRoute
  '/app/clubs/$slug/admin/moderation': typeof AppClubsSlugAdminModerationRoute
  '/app/clubs/$slug/admin': typeof AppClubsSlugAdminIndexRoute
  '/app/clubs/$slug/queues/$queueSlug/flow-editor': typeof AppClubsSlugQueuesQueueSlugFlowEditorRoute
  '/app/clubs/$slug/queues/$queueSlug/settings': typeof AppClubsSlugQueuesQueueSlugSettingsRoute
  '/app/clubs/$slug/queues/$queueSlug': typeof AppClubsSlugQueuesQueueSlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(public)': typeof publicRouteRouteWithChildren
  '/app': typeof AppRouteRouteWithChildren
  '/2fa': typeof R2faRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/app/admin': typeof AppAdminRouteRouteWithChildren
  '/app/games': typeof AppGamesRouteRouteWithChildren
  '/app/onboarding': typeof AppOnboardingRouteRouteWithChildren
  '/(public)/about': typeof publicAboutRoute
  '/(public)/features': typeof publicFeaturesRoute
  '/(public)/pricing': typeof publicPricingRoute
  '/(public)/privacy': typeof publicPrivacyRoute
  '/(public)/terms': typeof publicTermsRoute
  '/app/notifications': typeof AppNotificationsRoute
  '/app/profile': typeof AppProfileRoute
  '/app/settings': typeof AppSettingsRoute
  '/(public)/': typeof publicIndexRoute
  '/app/': typeof AppIndexRoute
  '/app/clubs/$slug': typeof AppClubsSlugRouteRouteWithChildren
  '/app/dev/flow-runner': typeof AppDevFlowRunnerRoute
  '/app/dev/node-preview': typeof AppDevNodePreviewRoute
  '/app/match/$shortId': typeof AppMatchShortIdRoute
  '/app/onboarding/step-1': typeof AppOnboardingStep1Route
  '/app/onboarding/step-2': typeof AppOnboardingStep2Route
  '/app/onboarding/step-3': typeof AppOnboardingStep3Route
  '/app/onboarding/step-4': typeof AppOnboardingStep4Route
  '/app/users/$slug': typeof AppUsersSlugRoute
  '/app/clubs/': typeof AppClubsIndexRoute
  '/app/games/': typeof AppGamesIndexRoute
  '/app/clubs/$slug/admin': typeof AppClubsSlugAdminRouteRouteWithChildren
  '/app/admin/games/$gameId': typeof AppAdminGamesGameIdRoute
  '/app/clubs/$slug/matches': typeof AppClubsSlugMatchesRoute
  '/app/clubs/$slug/members': typeof AppClubsSlugMembersRoute
  '/app/clubs/$slug/queue-settings': typeof AppClubsSlugQueueSettingsRoute
  '/app/clubs/$slug/settings': typeof AppClubsSlugSettingsRoute
  '/app/clubs/$slug/stats': typeof AppClubsSlugStatsRoute
  '/app/clubs/join/$code': typeof AppClubsJoinCodeRoute
  '/app/admin/games/': typeof AppAdminGamesIndexRoute
  '/app/clubs/$slug/': typeof AppClubsSlugIndexRoute
  '/app/games/$game/': typeof AppGamesGameIndexRoute
  '/app/clubs/$slug/admin/analytics': typeof AppClubsSlugAdminAnalyticsRoute
  '/app/clubs/$slug/admin/disputes': typeof AppClubsSlugAdminDisputesRoute
  '/app/clubs/$slug/admin/moderation': typeof AppClubsSlugAdminModerationRoute
  '/app/clubs/$slug/admin/': typeof AppClubsSlugAdminIndexRoute
  '/app/clubs/$slug/queues/$queueSlug/flow-editor': typeof AppClubsSlugQueuesQueueSlugFlowEditorRoute
  '/app/clubs/$slug/queues/$queueSlug/settings': typeof AppClubsSlugQueuesQueueSlugSettingsRoute
  '/app/clubs/$slug/queues/$queueSlug/': typeof AppClubsSlugQueuesQueueSlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/app'
    | '/2fa'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/app/admin'
    | '/app/games'
    | '/app/onboarding'
    | '/about'
    | '/features'
    | '/pricing'
    | '/privacy'
    | '/terms'
    | '/app/notifications'
    | '/app/profile'
    | '/app/settings'
    | '/'
    | '/app/'
    | '/app/clubs/$slug'
    | '/app/dev/flow-runner'
    | '/app/dev/node-preview'
    | '/app/match/$shortId'
    | '/app/onboarding/step-1'
    | '/app/onboarding/step-2'
    | '/app/onboarding/step-3'
    | '/app/onboarding/step-4'
    | '/app/users/$slug'
    | '/app/clubs/'
    | '/app/games/'
    | '/app/clubs/$slug/admin'
    | '/app/admin/games/$gameId'
    | '/app/clubs/$slug/matches'
    | '/app/clubs/$slug/members'
    | '/app/clubs/$slug/queue-settings'
    | '/app/clubs/$slug/settings'
    | '/app/clubs/$slug/stats'
    | '/app/clubs/join/$code'
    | '/app/admin/games/'
    | '/app/clubs/$slug/'
    | '/app/games/$game/'
    | '/app/clubs/$slug/admin/analytics'
    | '/app/clubs/$slug/admin/disputes'
    | '/app/clubs/$slug/admin/moderation'
    | '/app/clubs/$slug/admin/'
    | '/app/clubs/$slug/queues/$queueSlug/flow-editor'
    | '/app/clubs/$slug/queues/$queueSlug/settings'
    | '/app/clubs/$slug/queues/$queueSlug/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/2fa'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/app/admin'
    | '/app/onboarding'
    | '/about'
    | '/features'
    | '/pricing'
    | '/privacy'
    | '/terms'
    | '/app/notifications'
    | '/app/profile'
    | '/app/settings'
    | '/'
    | '/app'
    | '/app/dev/flow-runner'
    | '/app/dev/node-preview'
    | '/app/match/$shortId'
    | '/app/onboarding/step-1'
    | '/app/onboarding/step-2'
    | '/app/onboarding/step-3'
    | '/app/onboarding/step-4'
    | '/app/users/$slug'
    | '/app/clubs'
    | '/app/games'
    | '/app/admin/games/$gameId'
    | '/app/clubs/$slug/matches'
    | '/app/clubs/$slug/members'
    | '/app/clubs/$slug/queue-settings'
    | '/app/clubs/$slug/settings'
    | '/app/clubs/$slug/stats'
    | '/app/clubs/join/$code'
    | '/app/admin/games'
    | '/app/clubs/$slug'
    | '/app/games/$game'
    | '/app/clubs/$slug/admin/analytics'
    | '/app/clubs/$slug/admin/disputes'
    | '/app/clubs/$slug/admin/moderation'
    | '/app/clubs/$slug/admin'
    | '/app/clubs/$slug/queues/$queueSlug/flow-editor'
    | '/app/clubs/$slug/queues/$queueSlug/settings'
    | '/app/clubs/$slug/queues/$queueSlug'
  id:
    | '__root__'
    | '/(public)'
    | '/app'
    | '/2fa'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/app/admin'
    | '/app/games'
    | '/app/onboarding'
    | '/(public)/about'
    | '/(public)/features'
    | '/(public)/pricing'
    | '/(public)/privacy'
    | '/(public)/terms'
    | '/app/notifications'
    | '/app/profile'
    | '/app/settings'
    | '/(public)/'
    | '/app/'
    | '/app/clubs/$slug'
    | '/app/dev/flow-runner'
    | '/app/dev/node-preview'
    | '/app/match/$shortId'
    | '/app/onboarding/step-1'
    | '/app/onboarding/step-2'
    | '/app/onboarding/step-3'
    | '/app/onboarding/step-4'
    | '/app/users/$slug'
    | '/app/clubs/'
    | '/app/games/'
    | '/app/clubs/$slug/admin'
    | '/app/admin/games/$gameId'
    | '/app/clubs/$slug/matches'
    | '/app/clubs/$slug/members'
    | '/app/clubs/$slug/queue-settings'
    | '/app/clubs/$slug/settings'
    | '/app/clubs/$slug/stats'
    | '/app/clubs/join/$code'
    | '/app/admin/games/'
    | '/app/clubs/$slug/'
    | '/app/games/$game/'
    | '/app/clubs/$slug/admin/analytics'
    | '/app/clubs/$slug/admin/disputes'
    | '/app/clubs/$slug/admin/moderation'
    | '/app/clubs/$slug/admin/'
    | '/app/clubs/$slug/queues/$queueSlug/flow-editor'
    | '/app/clubs/$slug/queues/$queueSlug/settings'
    | '/app/clubs/$slug/queues/$queueSlug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  publicRouteRoute: typeof publicRouteRouteWithChildren
  AppRouteRoute: typeof AppRouteRouteWithChildren
  R2faRoute: typeof R2faRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/2fa': {
      id: '/2fa'
      path: '/2fa'
      fullPath: '/2fa'
      preLoaderRoute: typeof R2faRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)': {
      id: '/(public)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof publicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/(public)/': {
      id: '/(public)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicIndexRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/profile': {
      id: '/app/profile'
      path: '/profile'
      fullPath: '/app/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/notifications': {
      id: '/app/notifications'
      path: '/notifications'
      fullPath: '/app/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/(public)/terms': {
      id: '/(public)/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof publicTermsRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/privacy': {
      id: '/(public)/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof publicPrivacyRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/pricing': {
      id: '/(public)/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof publicPricingRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/features': {
      id: '/(public)/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof publicFeaturesRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/about': {
      id: '/(public)/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof publicAboutRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/app/onboarding': {
      id: '/app/onboarding'
      path: '/onboarding'
      fullPath: '/app/onboarding'
      preLoaderRoute: typeof AppOnboardingRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/games': {
      id: '/app/games'
      path: '/games'
      fullPath: '/app/games'
      preLoaderRoute: typeof AppGamesRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/admin': {
      id: '/app/admin'
      path: '/admin'
      fullPath: '/app/admin'
      preLoaderRoute: typeof AppAdminRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/games/': {
      id: '/app/games/'
      path: '/'
      fullPath: '/app/games/'
      preLoaderRoute: typeof AppGamesIndexRouteImport
      parentRoute: typeof AppGamesRouteRoute
    }
    '/app/clubs/': {
      id: '/app/clubs/'
      path: '/clubs'
      fullPath: '/app/clubs/'
      preLoaderRoute: typeof AppClubsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/users/$slug': {
      id: '/app/users/$slug'
      path: '/users/$slug'
      fullPath: '/app/users/$slug'
      preLoaderRoute: typeof AppUsersSlugRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/onboarding/step-4': {
      id: '/app/onboarding/step-4'
      path: '/step-4'
      fullPath: '/app/onboarding/step-4'
      preLoaderRoute: typeof AppOnboardingStep4RouteImport
      parentRoute: typeof AppOnboardingRouteRoute
    }
    '/app/onboarding/step-3': {
      id: '/app/onboarding/step-3'
      path: '/step-3'
      fullPath: '/app/onboarding/step-3'
      preLoaderRoute: typeof AppOnboardingStep3RouteImport
      parentRoute: typeof AppOnboardingRouteRoute
    }
    '/app/onboarding/step-2': {
      id: '/app/onboarding/step-2'
      path: '/step-2'
      fullPath: '/app/onboarding/step-2'
      preLoaderRoute: typeof AppOnboardingStep2RouteImport
      parentRoute: typeof AppOnboardingRouteRoute
    }
    '/app/onboarding/step-1': {
      id: '/app/onboarding/step-1'
      path: '/step-1'
      fullPath: '/app/onboarding/step-1'
      preLoaderRoute: typeof AppOnboardingStep1RouteImport
      parentRoute: typeof AppOnboardingRouteRoute
    }
    '/app/match/$shortId': {
      id: '/app/match/$shortId'
      path: '/match/$shortId'
      fullPath: '/app/match/$shortId'
      preLoaderRoute: typeof AppMatchShortIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/dev/node-preview': {
      id: '/app/dev/node-preview'
      path: '/dev/node-preview'
      fullPath: '/app/dev/node-preview'
      preLoaderRoute: typeof AppDevNodePreviewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/dev/flow-runner': {
      id: '/app/dev/flow-runner'
      path: '/dev/flow-runner'
      fullPath: '/app/dev/flow-runner'
      preLoaderRoute: typeof AppDevFlowRunnerRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/clubs/$slug': {
      id: '/app/clubs/$slug'
      path: '/clubs/$slug'
      fullPath: '/app/clubs/$slug'
      preLoaderRoute: typeof AppClubsSlugRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/games/$game/': {
      id: '/app/games/$game/'
      path: '/$game'
      fullPath: '/app/games/$game/'
      preLoaderRoute: typeof AppGamesGameIndexRouteImport
      parentRoute: typeof AppGamesRouteRoute
    }
    '/app/clubs/$slug/': {
      id: '/app/clubs/$slug/'
      path: '/'
      fullPath: '/app/clubs/$slug/'
      preLoaderRoute: typeof AppClubsSlugIndexRouteImport
      parentRoute: typeof AppClubsSlugRouteRoute
    }
    '/app/admin/games/': {
      id: '/app/admin/games/'
      path: '/games'
      fullPath: '/app/admin/games/'
      preLoaderRoute: typeof AppAdminGamesIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/clubs/join/$code': {
      id: '/app/clubs/join/$code'
      path: '/clubs/join/$code'
      fullPath: '/app/clubs/join/$code'
      preLoaderRoute: typeof AppClubsJoinCodeRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/clubs/$slug/stats': {
      id: '/app/clubs/$slug/stats'
      path: '/stats'
      fullPath: '/app/clubs/$slug/stats'
      preLoaderRoute: typeof AppClubsSlugStatsRouteImport
      parentRoute: typeof AppClubsSlugRouteRoute
    }
    '/app/clubs/$slug/settings': {
      id: '/app/clubs/$slug/settings'
      path: '/settings'
      fullPath: '/app/clubs/$slug/settings'
      preLoaderRoute: typeof AppClubsSlugSettingsRouteImport
      parentRoute: typeof AppClubsSlugRouteRoute
    }
    '/app/clubs/$slug/queue-settings': {
      id: '/app/clubs/$slug/queue-settings'
      path: '/queue-settings'
      fullPath: '/app/clubs/$slug/queue-settings'
      preLoaderRoute: typeof AppClubsSlugQueueSettingsRouteImport
      parentRoute: typeof AppClubsSlugRouteRoute
    }
    '/app/clubs/$slug/members': {
      id: '/app/clubs/$slug/members'
      path: '/members'
      fullPath: '/app/clubs/$slug/members'
      preLoaderRoute: typeof AppClubsSlugMembersRouteImport
      parentRoute: typeof AppClubsSlugRouteRoute
    }
    '/app/clubs/$slug/matches': {
      id: '/app/clubs/$slug/matches'
      path: '/matches'
      fullPath: '/app/clubs/$slug/matches'
      preLoaderRoute: typeof AppClubsSlugMatchesRouteImport
      parentRoute: typeof AppClubsSlugRouteRoute
    }
    '/app/admin/games/$gameId': {
      id: '/app/admin/games/$gameId'
      path: '/games/$gameId'
      fullPath: '/app/admin/games/$gameId'
      preLoaderRoute: typeof AppAdminGamesGameIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/clubs/$slug/admin': {
      id: '/app/clubs/$slug/admin'
      path: '/admin'
      fullPath: '/app/clubs/$slug/admin'
      preLoaderRoute: typeof AppClubsSlugAdminRouteRouteImport
      parentRoute: typeof AppClubsSlugRouteRoute
    }
    '/app/clubs/$slug/admin/': {
      id: '/app/clubs/$slug/admin/'
      path: '/'
      fullPath: '/app/clubs/$slug/admin/'
      preLoaderRoute: typeof AppClubsSlugAdminIndexRouteImport
      parentRoute: typeof AppClubsSlugAdminRouteRoute
    }
    '/app/clubs/$slug/admin/moderation': {
      id: '/app/clubs/$slug/admin/moderation'
      path: '/moderation'
      fullPath: '/app/clubs/$slug/admin/moderation'
      preLoaderRoute: typeof AppClubsSlugAdminModerationRouteImport
      parentRoute: typeof AppClubsSlugAdminRouteRoute
    }
    '/app/clubs/$slug/admin/disputes': {
      id: '/app/clubs/$slug/admin/disputes'
      path: '/disputes'
      fullPath: '/app/clubs/$slug/admin/disputes'
      preLoaderRoute: typeof AppClubsSlugAdminDisputesRouteImport
      parentRoute: typeof AppClubsSlugAdminRouteRoute
    }
    '/app/clubs/$slug/admin/analytics': {
      id: '/app/clubs/$slug/admin/analytics'
      path: '/analytics'
      fullPath: '/app/clubs/$slug/admin/analytics'
      preLoaderRoute: typeof AppClubsSlugAdminAnalyticsRouteImport
      parentRoute: typeof AppClubsSlugAdminRouteRoute
    }
    '/app/clubs/$slug/queues/$queueSlug/': {
      id: '/app/clubs/$slug/queues/$queueSlug/'
      path: '/queues/$queueSlug'
      fullPath: '/app/clubs/$slug/queues/$queueSlug/'
      preLoaderRoute: typeof AppClubsSlugQueuesQueueSlugIndexRouteImport
      parentRoute: typeof AppClubsSlugRouteRoute
    }
    '/app/clubs/$slug/queues/$queueSlug/settings': {
      id: '/app/clubs/$slug/queues/$queueSlug/settings'
      path: '/queues/$queueSlug/settings'
      fullPath: '/app/clubs/$slug/queues/$queueSlug/settings'
      preLoaderRoute: typeof AppClubsSlugQueuesQueueSlugSettingsRouteImport
      parentRoute: typeof AppClubsSlugRouteRoute
    }
    '/app/clubs/$slug/queues/$queueSlug/flow-editor': {
      id: '/app/clubs/$slug/queues/$queueSlug/flow-editor'
      path: '/queues/$queueSlug/flow-editor'
      fullPath: '/app/clubs/$slug/queues/$queueSlug/flow-editor'
      preLoaderRoute: typeof AppClubsSlugQueuesQueueSlugFlowEditorRouteImport
      parentRoute: typeof AppClubsSlugRouteRoute
    }
  }
}

interface publicRouteRouteChildren {
  publicAboutRoute: typeof publicAboutRoute
  publicFeaturesRoute: typeof publicFeaturesRoute
  publicPricingRoute: typeof publicPricingRoute
  publicPrivacyRoute: typeof publicPrivacyRoute
  publicTermsRoute: typeof publicTermsRoute
  publicIndexRoute: typeof publicIndexRoute
}

const publicRouteRouteChildren: publicRouteRouteChildren = {
  publicAboutRoute: publicAboutRoute,
  publicFeaturesRoute: publicFeaturesRoute,
  publicPricingRoute: publicPricingRoute,
  publicPrivacyRoute: publicPrivacyRoute,
  publicTermsRoute: publicTermsRoute,
  publicIndexRoute: publicIndexRoute,
}

const publicRouteRouteWithChildren = publicRouteRoute._addFileChildren(
  publicRouteRouteChildren,
)

interface AppAdminRouteRouteChildren {
  AppAdminGamesGameIdRoute: typeof AppAdminGamesGameIdRoute
  AppAdminGamesIndexRoute: typeof AppAdminGamesIndexRoute
}

const AppAdminRouteRouteChildren: AppAdminRouteRouteChildren = {
  AppAdminGamesGameIdRoute: AppAdminGamesGameIdRoute,
  AppAdminGamesIndexRoute: AppAdminGamesIndexRoute,
}

const AppAdminRouteRouteWithChildren = AppAdminRouteRoute._addFileChildren(
  AppAdminRouteRouteChildren,
)

interface AppGamesRouteRouteChildren {
  AppGamesIndexRoute: typeof AppGamesIndexRoute
  AppGamesGameIndexRoute: typeof AppGamesGameIndexRoute
}

const AppGamesRouteRouteChildren: AppGamesRouteRouteChildren = {
  AppGamesIndexRoute: AppGamesIndexRoute,
  AppGamesGameIndexRoute: AppGamesGameIndexRoute,
}

const AppGamesRouteRouteWithChildren = AppGamesRouteRoute._addFileChildren(
  AppGamesRouteRouteChildren,
)

interface AppOnboardingRouteRouteChildren {
  AppOnboardingStep1Route: typeof AppOnboardingStep1Route
  AppOnboardingStep2Route: typeof AppOnboardingStep2Route
  AppOnboardingStep3Route: typeof AppOnboardingStep3Route
  AppOnboardingStep4Route: typeof AppOnboardingStep4Route
}

const AppOnboardingRouteRouteChildren: AppOnboardingRouteRouteChildren = {
  AppOnboardingStep1Route: AppOnboardingStep1Route,
  AppOnboardingStep2Route: AppOnboardingStep2Route,
  AppOnboardingStep3Route: AppOnboardingStep3Route,
  AppOnboardingStep4Route: AppOnboardingStep4Route,
}

const AppOnboardingRouteRouteWithChildren =
  AppOnboardingRouteRoute._addFileChildren(AppOnboardingRouteRouteChildren)

interface AppClubsSlugAdminRouteRouteChildren {
  AppClubsSlugAdminAnalyticsRoute: typeof AppClubsSlugAdminAnalyticsRoute
  AppClubsSlugAdminDisputesRoute: typeof AppClubsSlugAdminDisputesRoute
  AppClubsSlugAdminModerationRoute: typeof AppClubsSlugAdminModerationRoute
  AppClubsSlugAdminIndexRoute: typeof AppClubsSlugAdminIndexRoute
}

const AppClubsSlugAdminRouteRouteChildren: AppClubsSlugAdminRouteRouteChildren =
  {
    AppClubsSlugAdminAnalyticsRoute: AppClubsSlugAdminAnalyticsRoute,
    AppClubsSlugAdminDisputesRoute: AppClubsSlugAdminDisputesRoute,
    AppClubsSlugAdminModerationRoute: AppClubsSlugAdminModerationRoute,
    AppClubsSlugAdminIndexRoute: AppClubsSlugAdminIndexRoute,
  }

const AppClubsSlugAdminRouteRouteWithChildren =
  AppClubsSlugAdminRouteRoute._addFileChildren(
    AppClubsSlugAdminRouteRouteChildren,
  )

interface AppClubsSlugRouteRouteChildren {
  AppClubsSlugAdminRouteRoute: typeof AppClubsSlugAdminRouteRouteWithChildren
  AppClubsSlugMatchesRoute: typeof AppClubsSlugMatchesRoute
  AppClubsSlugMembersRoute: typeof AppClubsSlugMembersRoute
  AppClubsSlugQueueSettingsRoute: typeof AppClubsSlugQueueSettingsRoute
  AppClubsSlugSettingsRoute: typeof AppClubsSlugSettingsRoute
  AppClubsSlugStatsRoute: typeof AppClubsSlugStatsRoute
  AppClubsSlugIndexRoute: typeof AppClubsSlugIndexRoute
  AppClubsSlugQueuesQueueSlugFlowEditorRoute: typeof AppClubsSlugQueuesQueueSlugFlowEditorRoute
  AppClubsSlugQueuesQueueSlugSettingsRoute: typeof AppClubsSlugQueuesQueueSlugSettingsRoute
  AppClubsSlugQueuesQueueSlugIndexRoute: typeof AppClubsSlugQueuesQueueSlugIndexRoute
}

const AppClubsSlugRouteRouteChildren: AppClubsSlugRouteRouteChildren = {
  AppClubsSlugAdminRouteRoute: AppClubsSlugAdminRouteRouteWithChildren,
  AppClubsSlugMatchesRoute: AppClubsSlugMatchesRoute,
  AppClubsSlugMembersRoute: AppClubsSlugMembersRoute,
  AppClubsSlugQueueSettingsRoute: AppClubsSlugQueueSettingsRoute,
  AppClubsSlugSettingsRoute: AppClubsSlugSettingsRoute,
  AppClubsSlugStatsRoute: AppClubsSlugStatsRoute,
  AppClubsSlugIndexRoute: AppClubsSlugIndexRoute,
  AppClubsSlugQueuesQueueSlugFlowEditorRoute:
    AppClubsSlugQueuesQueueSlugFlowEditorRoute,
  AppClubsSlugQueuesQueueSlugSettingsRoute:
    AppClubsSlugQueuesQueueSlugSettingsRoute,
  AppClubsSlugQueuesQueueSlugIndexRoute: AppClubsSlugQueuesQueueSlugIndexRoute,
}

const AppClubsSlugRouteRouteWithChildren =
  AppClubsSlugRouteRoute._addFileChildren(AppClubsSlugRouteRouteChildren)

interface AppRouteRouteChildren {
  AppAdminRouteRoute: typeof AppAdminRouteRouteWithChildren
  AppGamesRouteRoute: typeof AppGamesRouteRouteWithChildren
  AppOnboardingRouteRoute: typeof AppOnboardingRouteRouteWithChildren
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppProfileRoute: typeof AppProfileRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppClubsSlugRouteRoute: typeof AppClubsSlugRouteRouteWithChildren
  AppDevFlowRunnerRoute: typeof AppDevFlowRunnerRoute
  AppDevNodePreviewRoute: typeof AppDevNodePreviewRoute
  AppMatchShortIdRoute: typeof AppMatchShortIdRoute
  AppUsersSlugRoute: typeof AppUsersSlugRoute
  AppClubsIndexRoute: typeof AppClubsIndexRoute
  AppClubsJoinCodeRoute: typeof AppClubsJoinCodeRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppAdminRouteRoute: AppAdminRouteRouteWithChildren,
  AppGamesRouteRoute: AppGamesRouteRouteWithChildren,
  AppOnboardingRouteRoute: AppOnboardingRouteRouteWithChildren,
  AppNotificationsRoute: AppNotificationsRoute,
  AppProfileRoute: AppProfileRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppClubsSlugRouteRoute: AppClubsSlugRouteRouteWithChildren,
  AppDevFlowRunnerRoute: AppDevFlowRunnerRoute,
  AppDevNodePreviewRoute: AppDevNodePreviewRoute,
  AppMatchShortIdRoute: AppMatchShortIdRoute,
  AppUsersSlugRoute: AppUsersSlugRoute,
  AppClubsIndexRoute: AppClubsIndexRoute,
  AppClubsJoinCodeRoute: AppClubsJoinCodeRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  publicRouteRoute: publicRouteRouteWithChildren,
  AppRouteRoute: AppRouteRouteWithChildren,
  R2faRoute: R2faRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
